import { type Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountNaicsCodesQueryKey } from "../account.keys";

const EMPTY_NAICS_ROWS: Dtos.NaicsCode.List.Response = [];

export const useAdminFetchAccountSpecialtyCodes = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, isFetching, refetch } = useQuery({
		queryKey: accountNaicsCodesQueryKey(accountId),
		queryFn: async () =>
			await get<Dtos.NaicsCode.List.Response>(`/v2/admin/surety/accounts/${accountId}/naics-codes`),
	});

	return {
		rows: data ?? EMPTY_NAICS_ROWS,
		isLoading,
		isFetching,
		error: error ?? null,
		refetch,
	};
};
